<template>
  <div class="w-screen min-h-screen bg-white relative pb-20">
    <div class="w-full h-full overflow-y-auto overflow-x-hidden bg-white relative">
      <div class="w-full bg-white px-4 py-3 border-b border-gray-200 flex justify-between items-center print:hidden">
        <div class="font-bold text-blue-600 flex items-center gap-2 cursor-pointer" @click="$router.push({ name: 'Salary' })">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          KEMBALI
        </div>
      </div>

      <div class="px-4 pt-4">
        <h3 class="font-bold text-lg mb-4 text-green-600">Tambah Pekerjaan / Gaji Baru</h3>

        <div class="mb-3">
          <label class="block text-xs font-bold mb-1">Tanggal</label>
          <input type="date" v-model="gajiForm.tgl_laporan" class="w-full border p-2 rounded text-sm">
        </div>

        <div class="mb-3">
          <label class="block text-xs font-bold mb-1">Karyawan</label>
          <div class="relative">
            <input
              type="text"
              v-model="gajiUserSearch"
              @input="searchGajiUsers"
              @focus="onGajiUserFocus"
              @blur="hideGajiUserDropdownDelayed"
              class="w-full border p-2 rounded text-sm"
              placeholder="Cari nama karyawan..."
            >
            <div v-if="showGajiUserDropdown && filteredGajiUserList.length > 0" class="absolute w-full bg-white border border-gray-300 mt-1 max-h-60 overflow-y-auto shadow-lg z-10 rounded-md">
              <div
                v-for="user in filteredGajiUserList"
                :key="user.id"
                @click="selectGajiUser(user)"
                class="px-3 py-2 hover:bg-blue-100 cursor-pointer text-sm border-b last:border-b-0"
              >
                {{ user.label }}
              </div>
            </div>
          </div>
          <div v-if="gajiSelectedUser" class="mt-1 text-xs text-green-600 font-bold">
            Dipilih: {{ gajiSelectedUser.label }}
          </div>
        </div>

        <div class="mb-3">
          <label class="block text-xs font-bold mb-1">Nama Pekerjaan</label>
          <input type="text" v-model="gajiForm.nama_pekerjaan" class="w-full border p-2 rounded text-sm">
        </div>

        <div class="mb-3">
          <label class="block text-xs font-bold mb-1">Keterangan</label>
          <textarea v-model="gajiForm.keterangan" class="w-full border p-2 rounded text-sm" rows="2"></textarea>
        </div>

        <div class="mb-3">
          <label class="block text-xs font-bold mb-1">Harga Akhir (Rp)</label>
          <input type="number" v-model="gajiForm.harga_akhir" class="w-full border p-2 rounded text-sm">
        </div>

        <div class="flex justify-end gap-2 mt-4">
          <button @click="$router.push({ name: 'Salary' })" class="px-4 py-2 text-gray-600 text-sm hover:bg-gray-100 rounded">Batal</button>
          <button @click="submitGaji" class="px-4 py-2 bg-green-600 text-white text-sm hover:bg-green-700 rounded">Simpan</button>
        </div>

        <div class="mt-8 border-t pt-4">
            <h4 class="font-bold text-md text-gray-600 mb-2">Data Terinput:</h4>

            <div class="mb-3 flex items-center gap-2">
              <label class="text-xs font-bold text-gray-600">Bulan:</label>
              <input type="month" v-model="currentMonth" @change="fetchRecentSalaries" class="border rounded px-2 py-1 text-xs">
            </div>

            <div class="overflow-x-auto">
              <table class="w-full border-collapse border border-gray-400 text-xs text-left mb-8">
                <thead>
                  <tr class="bg-gray-100">
                    <th class="border border-gray-400 px-2 py-1 w-10 text-center">NO</th>
                    <th class="border border-gray-400 px-2 py-1 font-bold">KARYAWAN</th>
                    <th class="border border-gray-400 px-2 py-1 font-bold">PEKERJAAN</th>
                    <th class="border border-gray-400 px-2 py-1 font-bold">KETERANGAN</th>
                    <th class="border border-gray-400 px-2 py-1 font-bold text-right">HARGA (Rp)</th>
                    <th class="border border-gray-400 px-2 py-1 font-bold text-center">AKSI</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="recentSalaries.length === 0">
                    <td colspan="6" class="border border-gray-400 px-2 py-3 text-center text-gray-500 italic">Belum ada data di bulan ini</td>
                  </tr>
                  <tr v-for="(item, index) in recentSalaries" :key="item.id" class="hover:bg-gray-50">
                    <td class="border border-gray-400 px-2 py-1 text-center">{{ index + 1 }}</td>
                    <td class="border border-gray-400 px-2 py-1 font-medium">{{ item.nama }}<br><span class="text-[10px] text-gray-400">{{ formatDate(item.tgl_laporan) }}</span></td>
                    <td class="border border-gray-400 px-2 py-1">{{ item.nama_pekerjaan }}</td>
                    <td class="border border-gray-400 px-2 py-1">{{ item.keterangan }}</td>
                    <td class="border border-gray-400 px-2 py-1 text-right font-bold text-green-600">{{ formatCurrency(item.harga_akhir) }}</td>
                    <td class="border border-gray-400 px-2 py-1 text-center whitespace-nowrap">
                      <button @click="editItem(item)" class="text-blue-600 hover:text-blue-800 mr-2" title="Edit">✏️</button>
                      <button @click="deleteItem(item.id)" class="text-red-600 hover:text-red-800" title="Hapus">🗑️</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>

        <!-- Edit Modal -->
        <div v-if="showEditModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 print:hidden">
          <div class="bg-white p-6 rounded-lg w-96 shadow-xl">
            <h3 class="font-bold text-lg mb-4 text-blue-600">Edit Data Gaji</h3>

            <div class="mb-3">
              <label class="block text-xs font-bold mb-1">Tanggal</label>
              <input type="date" v-model="editForm.tgl_laporan" class="w-full border p-2 rounded text-sm">
            </div>

            <div class="mb-3">
              <label class="block text-xs font-bold mb-1">Nama Pekerjaan</label>
              <input type="text" v-model="editForm.nama_pekerjaan" class="w-full border p-2 rounded text-sm">
            </div>

            <div class="mb-3">
              <label class="block text-xs font-bold mb-1">Keterangan</label>
              <textarea v-model="editForm.keterangan" class="w-full border p-2 rounded text-sm" rows="2"></textarea>
            </div>

            <div class="mb-3">
              <label class="block text-xs font-bold mb-1">Harga Akhir (Rp)</label>
              <input type="number" v-model="editForm.harga_akhir" class="w-full border p-2 rounded text-sm">
            </div>

            <div class="flex justify-end gap-2 mt-4">
              <button @click="showEditModal = false" class="px-4 py-2 text-gray-600 text-sm hover:bg-gray-100 rounded">Batal</button>
              <button @click="submitEdit" class="px-4 py-2 bg-blue-600 text-white text-sm hover:bg-blue-700 rounded">Update</button>
            </div>
          </div>
        </div>

      </div>
    </div>
    <bottom-nav></bottom-nav>
  </div>
</template>

<script>
import BottomNav from '../components/BottomNav.vue'
import axios from 'axios'

export default {
  name: 'CreateSalary',
  components: { BottomNav },
  data () {
    return {
      allUserList: [],
      gajiUserSearch: '',
      showGajiUserDropdown: false,
      gajiSelectedUser: null,
      currentMonth: new Date().toISOString().slice(0, 7),
      recentSalaries: [],
      showEditModal: false,
      editForm: {
        id: '',
        tgl_laporan: '',
        nama_pekerjaan: '',
        keterangan: '',
        harga_akhir: ''
      },
      gajiForm: {
        user_id: '',
        tgl_laporan: new Date().toISOString().slice(0, 10),
        nama_pekerjaan: '',
        keterangan: '',
        harga_akhir: ''
      }
    }
  },
  computed: {
    token () {
      return this.$store.state.token
    },
    filteredGajiUserList () {
      if (!this.gajiUserSearch) {
        return this.allUserList
      }
      const query = this.gajiUserSearch.toLowerCase()
      return this.allUserList.filter(u => u.label.toLowerCase().includes(query))
    }
  },
  methods: {
    async fetchAllUsers () {
      if (this.allUserList.length > 0) return
      try {
        const response = await axios.get(`e_kinerja/laporan/get_users_search?term=&token=${this.token}&t=` + new Date().getTime())
        this.allUserList = response.data
      } catch (error) {
        console.error('Error fetching users:', error)
      }
    },
    async onGajiUserFocus () {
      await this.fetchAllUsers()
      this.showGajiUserDropdown = true
    },
    searchGajiUsers () {
      this.showGajiUserDropdown = true
    },
    hideGajiUserDropdownDelayed () {
      setTimeout(() => {
        this.showGajiUserDropdown = false
      }, 200)
    },
    selectGajiUser (user) {
      this.gajiSelectedUser = user
      this.gajiForm.user_id = user.id
      this.gajiUserSearch = user.label
      this.showGajiUserDropdown = false
    },
    async submitGaji () {
      if (!this.gajiForm.tgl_laporan || !this.gajiForm.user_id || !this.gajiForm.nama_pekerjaan || !this.gajiForm.harga_akhir) {
        alert('Mohon lengkapi data (Tanggal, Karyawan, Nama Pekerjaan, Harga Akhir)')
        return
      }

      try {
        const response = await axios.post('e_kinerja/laporan/store_gaji?token=' + this.token, this.gajiForm)
        if (response.data.status === 'success') {
          alert('Gaji berhasil ditambahkan')
          this.resetGajiForm()
          this.fetchRecentSalaries()
        } else {
          alert('Gagal menyimpan gaji')
        }
      } catch (error) {
        console.error('Error submitting gaji:', error)
        alert('Terjadi kesalahan saat menyimpan data.')
      }
    },
    resetGajiForm () {
      this.gajiForm.tgl_laporan = new Date().toISOString().slice(0, 10)
      this.gajiForm.nama_pekerjaan = ''
      this.gajiForm.keterangan = ''
      this.gajiForm.harga_akhir = ''
    },
    async fetchRecentSalaries () {
      try {
        const response = await axios.get(`e_kinerja/laporan/get_recent_gaji?bulan=${this.currentMonth}&token=${this.token}`)
        if (response.data.status === 'success') {
          this.recentSalaries = response.data.data
        }
      } catch (error) {
        console.error('Error fetching recent salaries:', error)
      }
    },
    editItem (item) {
      this.editForm = {
        id: item.id,
        tgl_laporan: item.tgl_laporan ? item.tgl_laporan.slice(0, 10) : '',
        nama_pekerjaan: item.nama_pekerjaan,
        keterangan: item.keterangan,
        harga_akhir: item.harga_akhir
      }
      this.showEditModal = true
    },
    async submitEdit () {
      try {
        const response = await axios.post('e_kinerja/laporan/update_gaji_api?token=' + this.token, this.editForm)
        if (response.data.status === 'success') {
          alert('Data berhasil diupdate')
          this.showEditModal = false
          this.fetchRecentSalaries()
        } else {
          alert('Gagal mengupdate data')
        }
      } catch (error) {
        console.error('Error updating data:', error)
        alert('Terjadi kesalahan saat mengupdate data.')
      }
    },
    async deleteItem (id) {
      if (!confirm('Yakin ingin menghapus data ini?')) return
      try {
        const response = await axios.post('e_kinerja/laporan/delete_gaji_api?token=' + this.token, { id: id })
        if (response.data.status === 'success') {
          alert('Data berhasil dihapus')
          this.fetchRecentSalaries()
        } else {
          alert('Gagal menghapus data')
        }
      } catch (error) {
        console.error('Error deleting data:', error)
        alert('Terjadi kesalahan saat menghapus data.')
      }
    },
    formatCurrency (value) {
      if (!value) return '0'
      return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(value)
    },
    formatDate (dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return new Intl.DateTimeFormat('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }).format(date)
    }
  },
  mounted () {
    this.fetchAllUsers()
    this.fetchRecentSalaries()
  }
}
</script>
